import { Button, Spacer, ExpiredSessionImage } from '@percent/lemonade'
import styles from './ExpiredSessionHandle.module.scss'
import { CentralCardLayout } from '@percent/domain/iam'
import { ExpiredSessionHandleProps } from './ExpiredSessionHandle.types'

export function ExpiredSessionHandle({
  heading,
  description,
  buttonText,
  onButtonClick,
  footer,
}: ExpiredSessionHandleProps) {
  return (
    <CentralCardLayout
      CustomHeaderImage={
        <img
          src={ExpiredSessionImage}
          alt="expired session"
          className={styles.sessionImage}
        />
      }
      footer={footer}
    >
      <h5 className={styles.sessionExpiredText}>{heading}</h5>
      <p className={styles.loggedOutText}>{description}</p>
      <Spacer size={5} axis="vertical" />
      <Button stretch size="large" onClick={onButtonClick}>
        {buttonText}
      </Button>
    </CentralCardLayout>
  )
}
